import React, { FC, useMemo, useState } from 'react'

import { useZoneMenu } from 'modulesCommon/serviceHooks'
import { ZoneMenuItemType } from './ZoneMenu.props'
import ZoneMenuWrapper from './ZoneMenuWrapper'
import { SearchZone } from 'components'
import ZoneMenuItem from './ZoneMenuItem'
import { ENABLED_FEATURES } from '../../../../shared/utils/featureFlags'
import { Can } from '../../../../shared/abilities'
import { Link } from 'react-router-dom'
import { Icon, Tooltip } from '@wmgtech/legato'

// interface ISpaceOption {
//   label: string
//   value: string
//   subtitle: ReadonlyArray<{
//     name: string
//     alias: string
//   }>
// }

// function spaceOptionAdapter({ subtitle, ...rest }: ISpaceOption) {
//   return {
//     ...rest,
//     subtitle: `(${subtitle.map(({ alias }) => alias).join(', ')})`,
//     tooltip: subtitle.map(({ name }) => name).join(', ')
//   }
// }

const ZoneMenu: FC = () => {
  const [filterTerm, setFilterTerm] = useState<string>('')
  const {
    countryCode,
    zoneOptions,
    // spacesOptions,
    countryOptions,
    currentSpace,
    currentZone,
    // onSelectSpace,
    onSelectLabel,
    onSelectCountry
  } = useZoneMenu()


  const filteredZoneOptions = useMemo(
    () => zoneOptions.filter(f => f.label.toLowerCase().includes(filterTerm.toLowerCase())),
    [filterTerm, zoneOptions]
  )
  if (!currentZone || !countryCode) return null
  return (
    <ZoneMenuWrapper currentSpace={currentSpace} currentLabelTitle={currentZone.name} countryCode={countryCode}>
      <div className="zone-menu-container">
        <SearchZone
          zoneSearchHandler={setFilterTerm}
          searchBoxIconName={'magnifying-glass'}
          placeholder="Search Storybox Zones"
        />
        <div className="zone-menu-container-items">
          <div className="zone-menu-container__item">
            <div>
              {ENABLED_FEATURES.GLOBALHUB && (
                <Can do={'access'} on={'GlobalHub'}>
                  <div className={'items-list'}>
                    <Link
                      to="/globalhub"
                      className="zone-menu-container__item-heading zone-menu-container__item-heading--gh items-list__item">
                      <Icon className="zone-menu-container__icon" name="globe" />
                      <span>Global Hub</span>
                      <Tooltip message={'Where International marketing teams can share global projects and stories'}>
                        <Icon name={'info-circle'} className={'zone-menu-container__help-icon'}/>
                      </Tooltip>
                    </Link>
                  </div>
                </Can>
              )}
              <ZoneMenuItem
                type={ZoneMenuItemType.ZONE}
                options={filteredZoneOptions}
                onSelect={onSelectLabel}
                value={currentZone?.id.toString()}
              />
              {/*<ZoneMenuItem*/}
              {/*  type={ZoneMenuItemType.SPACES}*/}
              {/*  options={spacesOptions.map(spaceOptionAdapter)}*/}
              {/*  onSelect={onSelectSpace}*/}
              {/*  value={currentSpace?.id}*/}
              {/*/>*/}
            </div>
          </div>
          <div className="zone-menu-container__divider"></div>
          <div className="zone-menu-container__item">
            <ZoneMenuItem
              type={ZoneMenuItemType.COUNTRY}
              options={countryOptions || []}
              onSelect={onSelectCountry}
              value={countryCode}
            />
          </div>
        </div>
      </div>
    </ZoneMenuWrapper>
  )
}

export default ZoneMenu
